// The account control as a top-right ICON BUTTON + popout (Brief 4 polish). The
// trigger is icon-only; the popout shows who's signed in (display name + email,
// the profile-related identity) and a Log out action. Logout wipes the kept
// session and reloads to "/", where the orchestrator gate (GatedShell) re-reads
// the now-empty token and lands on sign-in. (clearSession only clears the auth
// keys, not the 4-digit code gate, so you drop to sign-in — not the code gate.)
// Token-pure (var(--waytide-sys-*)).

import { useRef, useState } from "react";
import { Download, LogOut, User } from "lucide-react";
import { Link } from "react-router-dom";
import { clearSession, getUser } from "../api/client";
import { useOutsideClose } from "../shell/useOutsideClose";

export function AccountMenu() {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useOutsideClose(open, ref, () => setOpen(false));
  const user = getUser();

  function logout() {
    clearSession();
    window.location.assign("/");
  }

  return (
    <div className="wt-topbar__menu" ref={ref}>
      <button
        type="button"
        className="wt-topbar__btn"
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label="Account"
        data-testid="account-menu-trigger"
        onClick={() => setOpen((o) => !o)}
      >
        <User size={18} aria-hidden="true" />
      </button>
      {open ? (
        <div
          className="wt-topbar__pop wt-topbar__pop--account"
          role="menu"
          aria-label="Account"
        >
          <div className="wt-topbar__identity">
            <span className="wt-topbar__name">
              {user?.display_name || "Signed in"}
            </span>
            {user?.email ? (
              <span className="wt-topbar__email">{user.email}</span>
            ) : null}
          </div>
          <div className="wt-topbar__divider" role="separator" />
          <Link
            to="/download"
            role="menuitem"
            className="wt-topbar__item"
            data-testid="account-get-apps"
            onClick={() => setOpen(false)}
          >
            <Download
              size={16}
              aria-hidden="true"
              className="wt-topbar__item-icon"
            />
            <span className="wt-topbar__item-label">Get the apps</span>
          </Link>
          <button
            type="button"
            role="menuitem"
            className="wt-topbar__item"
            data-testid="account-logout"
            onClick={logout}
          >
            <LogOut size={16} aria-hidden="true" className="wt-topbar__item-icon" />
            <span className="wt-topbar__item-label">Log out</span>
          </button>
        </div>
      ) : null}
    </div>
  );
}
